export const MEDIA_BASE = 'media/MEDIA_BASE';
export const DEMOS_QUERY = 'media/DEMOS_QUERY';
export const LIBRARY_DEMO_LOADING = 'media/LIBRARY_DEMO_LOADING';
export const LIBRARY_DEMO_LOADED = 'media/LIBRARY_DEMO_LOADED';
export const LIBRARY_DEMO_ADDED = 'media/LIBRARY_DEMO_ADDED';
export const LIBRARY_DEMO_ASSIGNED = 'media/LIBRARY_DEMO_ASSIGNED';
export const IMAGES_QUERY = 'media/IMAGES_QUERY';
export const LIBRARY_IMAGES_LOADING = 'media/LIBRARY_IMAGES_LOADING';
export const LIBRARY_IMAGES_LOADED = 'media/LIBRARY_IMAGES_LOADED';
export const VIDEOS_QUERY = 'media/VIDEOS_QUERY';
export const LIBRARY_VIDEOS_LOADING = 'media/LIBRARY_VIDEOS_LOADING';
export const LIBRARY_VIDEOS_LOADED = 'media/LIBRARY_VIDEOS_LOADED';
